import React, { FC } from 'react';
import styles from './notification-badge.module.css';

interface NotificationBadgeProps {
  count: number;
  maxCount?: number;
}

const NotificationBadge: FC<NotificationBadgeProps> = ({ count, maxCount = 99 }) => {
  if (count <= 0) return null;

  const displayCount = count > maxCount ? `${maxCount}+` : count.toString();

  return (
    <div className={styles.badge}>
      <span className={styles.count}>{displayCount}</span>
    </div>
  );
};

export default NotificationBadge;